import { useMutation } from "@tanstack/react-query";
import { appointmentService } from "..";
import { CreateMerchantServicePayload } from "../type";

function useCreateMerchantService() {
  return useMutation({
    mutationFn: (command: CreateMerchantServicePayload) => {
      return appointmentService.addMerchantServices(command);
    },
  });
}

export default useCreateMerchantService;
